import React, { useEffect, useState } from "react";
import VendorTable from "../tables/Vendor-Table/vendorTable";
import Header from "../header";
import SearchField from "../../searchField";
import Button from "../../Button";
import { FiPlus } from "react-icons/fi";
import Modal from "../../modal";
import Input from "../../Input";
import { useDispatch, useSelector } from "react-redux";
import { GetUsersData } from "../../../redux/Auth/actions";
import MultiSelectDropdown from "../../multiSelectDropdown";
import {
  AddVendor,
  getVendors,
  UpdateVendor,
} from "../../../redux/vendors/action";
import { useNavigate } from "react-router-dom";
import {
  validateselectedIdForm,
  validateVendorForm,
} from "../../../validation/VendorValidation";

const Vendors = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [currentRow, setCurrentRow] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({
    name: "",
    pendingamount: "",
    stores: [""],
    address: "",
  });
  const [filter] = useState({
    page: 1,
    limit: 10,
    search: "",
  });
  const [storeLimit, setStoreLimit] = useState(20);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [paymentSelectedIdErrors, setPaymentSelectedIdErrors] = useState();
  const [searchValue, setSearchValue] = useState("");

  const openModal = () => {
    setSelectedId([]);
    setIsEditMode(false);
    setIsOpen(true);
    setErrors({});
    resetForm();
  };
  const closeModal = () => {
    setSelectedId([]);
    setIsOpen(false);
    resetForm();
  };

  const getStore = useSelector((state) => state?.Auth?.usersData?.data);

  const options =
    getStore?.map((e) => ({
      label: e?.store?.name ? e?.store?.name : e?.user?.name,
      value: e?._id,
    })) || [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (isSubmit) {
      // OnChange validation
      const validationErrors = validateVendorForm({
        ...data,
        [name]: value,
      });
      setErrors(validationErrors);
    }
  };

  const resetForm = () => {
    setData({
      name: "",
      pendingamount: "",
      stores: [""],
      address: "",
    });
    setIsSubmit(false);
  };

  const openEditModal = (row) => {
    const storeIds = row?.stores?.map((store) => store._id);
    setData({
      name: row?.name,
      pendingamount: Number(row?.pendingamount),
      stores: storeIds,
      address: row?.address,
    });
    setSelectedId(storeIds);
    setIsOpen(true);
    setIsEditMode(true);
    setCurrentRow(row);
  };

  const handleSubmit = async () => {
    setIsSubmit(true);
    const validationErrors = validateVendorForm(data);
    const selectedIdErrors = validateselectedIdForm(selectedId);
    setErrors(validationErrors);
    setPaymentSelectedIdErrors(selectedIdErrors);

    if (Object.keys(validationErrors).length === 0 && !selectedIdErrors) {
      try {
        setLoading(true);
        let obj = {
          name: data?.name,
          pendingamount: Number(data?.pendingamount),
          stores: selectedId,
          address: data?.address,
        };

        if (isEditMode) {
          await dispatch(UpdateVendor({ id: currentRow?._id, data: obj })).then(
            (res) => {
              if (res?.status === 200) {
                dispatch(
                  getVendors({
                    page: filter?.page,
                    limit: filter?.limit,
                    search: searchValue,
                  })
                );
                setLoading(false);
              }
              if (res?.data?.status === 401) {
                setLoading(false);
                navigate("/");
              }
            }
          );
        } else {
          await dispatch(AddVendor(obj)).then((res) => {
            if (res?.status === 200) {
              dispatch(
                getVendors({
                  page: filter?.page,
                  limit: filter?.limit,
                  search: searchValue,
                })
              );
              setLoading(false);
            } else if (res?.status === 401) {
              setLoading(false);
              navigate("/");
            }
          });
        }
        setLoading(false);
      } catch (error) {
        console.log("error", error);
        setLoading(false);
        return error;
      }
      resetForm();
      closeModal();
    }
  };

  const fetchMoreData = () => {
    const newLimit = storeLimit + 10;
    setStoreLimit(newLimit);
  };

  useEffect(() => {
    dispatch(
      GetUsersData({
        page: filter?.page,
        limit: storeLimit,
        search: filter?.search,
      })
    ).then((res) => {
      if (res?.data?.length === 0) {
        setHasMoreData(false); // No more data to fetch
      }
      if (res.data?.status === 401) {
        navigate("/");
      }
    });
  }, [dispatch, navigate, filter, storeLimit, hasMoreData]);

  useEffect(() => {
    if (isSubmit) {
      const selectedIdErrors = validateselectedIdForm(selectedId);
      setPaymentSelectedIdErrors(selectedIdErrors);
    }
  }, [isSubmit, selectedId]);

  return (
    <div className="w-full px-8 py-2 flex flex-col gap-[30px]">
      <Header title={"Vendors"} />

      <div className="flex items-center justify-end gap-5">
        <SearchField
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />
        <Button
          onClick={openModal}
          className={"bg-green hover:bg-darkgreen text-white"}
          icon={<FiPlus />}
          children={"Add New Vendors"}
        />
      </div>

      <Modal
        loading={loading}
        modalWidth={"w-1/2"}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        openModal={openModal}
        closeModal={closeModal}
        imgSrc="/images/addVendors.svg"
        title={isEditMode ? "Update Vendor" : "Add New Vendor"}
        btn1="Cancel"
        btn2={isEditMode ? "Save" : "Add Vendor"}
        btnClass={"justify-end"}
        modalContent={
          <div className="grid grid-cols-2 gap-x-5 gap-y-5 text-base font-normal">
            <div>
              <Input
                lableName={"Name"}
                inputType={"text"}
                onChange={handleChange}
                value={data?.name}
                name={"name"}
              />
              {errors.name && <div className="text-red-500">{errors.name}</div>}
            </div>

            <div>
              <Input
                lableName={"Pending Amount"}
                inputType={"number"}
                currency={true}
                onChange={handleChange}
                value={data?.pendingamount}
                name={"pendingamount"}
              />
              {errors.pendingamount && (
                <div className="text-red-500">{errors.pendingamount}</div>
              )}
            </div>

            <div>
              <MultiSelectDropdown
                options={options}
                setSelectedId={setSelectedId}
                lableName={"Stores"}
                className={"col-span-2"}
                selectedValues={selectedId}
                fetchMoreData={fetchMoreData} // Pass the function
                hasMoreData={hasMoreData}
              />
              {paymentSelectedIdErrors && (
                <div className="text-red-500 text-sm">
                  {paymentSelectedIdErrors}
                </div>
              )}
            </div>

            <div>
              <Input
                lableName={"Address"}
                textarea={true}
                onChange={handleChange}
                value={data?.address}
                name={"address"}
              />
              {errors.address && (
                <div className="text-red-500">{errors.address}</div>
              )}
            </div>
          </div>
        }
        handleBtn2={handleSubmit}
      />

      <VendorTable openEditModal={openEditModal} searchValue={searchValue} />
    </div>
  );
};

export default Vendors;
